import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const postStagedTransactionsStep = defineStepConfig({
  type: "post_staged_transactions",
  name: "Post Staged Transactions",
  description:
    "Posts all staged E844D transactions for the organization, freezing them " +
    "so they can only be batched and sent. Logs POSTED activity per row.",
  category: "Transformation",
  libraryModule: "ShipAndDebit",
  inputSchema: z.object({}),
  outputSchema: z.object({
    postedCount: z
      .number()
      .describe("Number of transactions moved from staged to posted"),
  }),
  configSchema: z.object({}),
  emits: [] as const,
  execution: {
    startToCloseTimeout: "10 minutes",
    retry: { maximumAttempts: 2 },
  },
});
